"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useIconSize2 = require("@cbhq/cds-common/hooks/useIconSize");
var _glyphMap = _interopRequireDefault(require("@cbhq/cds-icons/__generated__/glyphMap"));
var _cdsUtils = require("@cbhq/cds-utils");
var _usePalette = require("../hooks/usePalette");
var _Box = require("../layout/Box");
var _iconStyles = require("./iconStyles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Icon = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(({
  accessibilityLabel,
  // TODO: border not implemented.
  bordered = false,
  color = 'primary',
  dangerouslySetColor,
  fallback = null,
  name,
  size,
  testID,
  // Spacing
  spacing,
  spacingTop,
  spacingBottom,
  spacingStart,
  spacingEnd,
  spacingVertical,
  spacingHorizontal
}, ref) => {
  const _useIconSize = (0, _useIconSize2.useIconSize)(size, bordered),
    iconSize = _useIconSize.iconSize,
    wrapperSize = _useIconSize.wrapperSize,
    sourceSize = _useIconSize.sourceSize;
  const palette = (0, _usePalette.usePalette)();
  const paletteColor = color === 'currentColor' ? color : palette[color];
  const finalColor = dangerouslySetColor !== null && dangerouslySetColor !== void 0 ? dangerouslySetColor : paletteColor;
  const glyphTestId = testID ? `${testID}-glyph` : 'icon-base-glyph';
  const glyphKey = `ui-${name}-${sourceSize}`;
  const glyph = _glyphMap.default[glyphKey];
  if (glyph === undefined) {
    if ((0, _cdsUtils.isDevelopment)()) {
      // eslint-disable-next-line no-console
      console.error(`Unable to find Icon with name: ${name}. Full internal lookup name is ${glyphKey}`);
    }
    return fallback;
  }
  return /*#__PURE__*/_react.default.createElement(_Box.Box, {
    position: "relative",
    spacing: spacing,
    spacingBottom: spacingBottom,
    spacingEnd: spacingEnd,
    spacingHorizontal: spacingHorizontal,
    spacingStart: spacingStart,
    spacingTop: spacingTop,
    spacingVertical: spacingVertical
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": testID,
    style: {
      width: wrapperSize,
      height: wrapperSize
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    ref: ref,
    "aria-hidden": !accessibilityLabel,
    "aria-label": accessibilityLabel,
    className: _iconStyles.iconStyles,
    "data-icon-name": name,
    "data-testid": glyphTestId,
    role: "img",
    style: {
      color: finalColor,
      fontSize: iconSize
    },
    title: accessibilityLabel
  }, glyph)));
}));
exports.Icon = Icon;